module.exports = __webpack_public_path__ + "yz/img/天猫.ace1b9a0.jpg";